import UriTemplate from 'uri-templates';

function ProductService($q, halClient, BBModel, $log, $rootScope) {
    'ngInject';

    return {
        getProduct(prms) {
            let href, uri;
            const deferred = $q.defer();

            if (prms.id) {
                href = $rootScope.bb.api_url + '/api/v1/{company_id}/products/{id}';
                uri = new UriTemplate(href).fillFromObject({company_id: prms.company_id, id: prms.product_id});
            } else if (prms.sku) {
                href = $rootScope.bb.api_url + '/api/v1/{company_id}/products/find_by_sku/{sku}';
                uri = new UriTemplate(href).fillFromObject({company_id: prms.company_id, sku: prms.sku});
            } else {
                $log.warn('id or sku is required');
                deferred.reject();
            }

            halClient.$get(uri, {}).then(product => deferred.resolve(new BBModel.Product((product)))
                , (err) => {
                    return deferred.reject(err);
                }
            );

            return deferred.promise;
        },


        query(company) {
            const deferred = $q.defer();
            if (!company.$has('products')) {
                deferred.reject('No products found');
            } else {
                company.$get('products').then((resource) => {
                        return resource.$get('products').then((items) => {
                                const resources = [];
                                for (const i of Array.from(items)) {
                                    resources.push(new BBModel.Product(i));
                                }
                                return deferred.resolve(resources);
                            }
                        );
                    }
                    , (err) => {
                        return deferred.reject(err);
                    }
                );
            }
            return deferred.promise;
        }
    };
}

angular
    .module('BB')
    .service('ProductService', ProductService);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/product.service.js